import type { MutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import { queryClient } from '@/_config/lib/react-query/query-client';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { GET_MISSION_BY_ID } from './get-mission-by-id';
import { GET_MISSIONS } from './get-missions';

interface PutCancelMissionParams {
  missionId: string;
}

const putCancelMission = async ({ missionId }: PutCancelMissionParams) =>
  apiClient
    .put(`/missions/${missionId}/cancel`)
    .then(response =>
      handleResponseSuccess(response, 'Missão desativada com sucesso!')(),
    )
    .catch(handleResponseThrowError('Não foi possível cancelar a missão.'));

export const usePutCancelMission = ({
  onSuccess,
  ...options
}: MutationOptions<unknown, unknown, PutCancelMissionParams> = {}) => {
  return useMutation({
    mutationFn: putCancelMission,
    onSuccess: (...args) => {
      queryClient.invalidateQueries([GET_MISSIONS], { exact: false });
      queryClient.invalidateQueries([GET_MISSION_BY_ID], { exact: false });
      onSuccess?.(...args);
    },
    ...options,
  });
};
